module.exports = __webpack_public_path__ + "img/EXTERIOR-BALENO-1.324b5733.jpg";